<template>
  <span style="display: inline-block;">
    <b-dropdown
      variant="outline-primary"
      size="sm"
      toggle-class="btn-custom-email"
      right
      :disabled="desabilitado"
    >
      <template #button-content>
        <feather-icon
          icon="SendIcon"
          class="text-primary mr-50"
          size="18"
        />
        Enviar por e-mail
      </template>
      <b-dropdown-item
        v-for="opcao in opcoesDestinatario"
        :key="opcao.value"
        @click="selecionarDestinatario(opcao.value)"
      >
        {{ opcao.label }}
      </b-dropdown-item>
    </b-dropdown>

    <b-modal
      ref="modalEnviarEmail"
      size="lg"
      no-close-on-backdrop
      :no-enforce-focus="true"
      :hide-header-close="true"
      @hidden="fecharModalEnviarEmail"
    >
      <template #modal-title>
        <h3 style="word-break: break-all;">
          {{ title }} para {{ parcelamento.razaoSocial }}
        </h3>
      </template>
      <div style="margin-top: 20px;">
        <label for="mensagens-adicional">Mensagem adicional</label>
        <b-form-textarea
          v-model="mensagemAdicional"
          style="height: 10rem;"
          input-id="mensagens-adicional"
        />
      </div>

      <template #modal-footer>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-success btn-none"
          style="margin-left: 0.3rem;"
          @click="enviarEmailLote"
        >
          Enviar
        </b-btn>
        <b-btn
          variant="none"
          size="sm"
          class="btn-outline-danger btn-none"
          style="margin-left: 0.3rem;"
          @click="fecharModalEnviarEmail"
        >
          Cancelar
        </b-btn>
      </template>
    </b-modal>

    <envio-email
      ref="modalEnvioEmailUnico"
      :title="`Enviar e-mail para ${parcelamento.razaoSocial}`"
      :sugestao="[]"
      :sugestao-email-adicional="null"
      @enviarEmail="enviarSF($event)"
      @hide="fecharEnvioUnico"
    />

    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Enviando email'"
    />
  </span>
</template>

<script>
import EnvioEmail from '@/app/shared/components/envio-email/EnvioEmail.vue'

export default {
  name: 'ModalEmailEmLoteParcelamento',
  components: {
    EnvioEmail,
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  props: {
    title: {
      type: String,
      default: 'Envio de email',
    },
    linhasSelecionadas: {
      type: Array,
      default: () => [],
    },
    parcelamento: {
      type: Object,
      required: true,
    },
    alterarStyle: {
      type: String,
      default: 'white-space: nowrap;',
    },
    evento: {
      type: Function,
      default: null,
    },
    nomeArquivo: {
      type: String,
      required: true,
    },
    desabilitado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mensagemAdicional: null,
      isLoading: false,
      mostrarEnvioUnico: false,
      tipoDestinatario: null,
      opcoesDestinatario: [
        { value: 'principal', label: 'Apenas e-mail principal' },
        { value: 'adicional', label: 'Apenas e-mail adicional' },
        { value: 'ambos', label: 'Ambos os e-mails' },
      ],
    }
  },
  methods: {
    selecionarDestinatario(tipo) {
      this.tipoDestinatario = tipo
      this.verificarEmail()
    },
    verificarEmail() {
      const temEmail = this.parcelamento && this.parcelamento.emailEmpresa && this.parcelamento.emailEmpresa.length > 0

      this.$emit('opening-modal')
      this.$nextTick(() => {
        if (!temEmail) {
          this.$erro('Nenhum e-mail cadastrado.')
          this.$refs.modalEnvioEmailUnico.abrirModal()
        } else {
          this.mensagemAdicional = null
          this.$refs.modalEnviarEmail.show()
        }
      })
    },
    fecharModalEnviarEmail() {
      this.$refs.modalEnviarEmail.hide()
      this.$emit('closing-modal')
    },
    fecharEnvioUnico() {
      this.$emit('closing-modal')
    },
    enviarSF(itens) {
      // itens = { emailsPara, emailsCc, mensagensAdicional, definirEmailPadroes }
      this.isLoading = true
      const empresaEmail = [{
        empresaId: this.parcelamento.id,
        emailAdicionalEmpresa: itens.emailsCc,
        email: itens.emailsPara,
        mensagensAdicional: itens.mensagensAdicional,
        definirEmailPadrao: itens.definirEmailPadroes,
      }]

      this.chamarApiEnvio(empresaEmail, 'ambos')
    },
    enviarEmailLote() {
      this.$refs.modalEnviarEmail.hide()
      const empresaEmail = [{
        empresaId: this.parcelamento.id,
        emailAdicionalEmpresa: null,
        email: null,
        mensagensAdicional: this.mensagemAdicional,
        definirEmailPadrao: false,
      }]

      this.chamarApiEnvio(empresaEmail, this.tipoDestinatario)
    },
    chamarApiEnvio(empresaEmail, tipoDestinatario) {
      this.isLoading = true

      this.evento(this.nomeArquivo, {
        docs: this.linhasSelecionadas,
        empresas: [this.parcelamento.id],
        empresasEmail: empresaEmail,
        tipoDestinatario,
        parcelamentoId: this.parcelamento.id,
      }).then(payload => {
        if (payload && payload.data && payload.data.length > 0) {
          this.$erro(`Erro ao enviar o e-mail: ${payload.data.join(', ')}`)
        } else {
          this.$sucesso('E-mail enviado com sucesso')
        }
      }).catch(err => {
        this.$erro('Erro ao enviar o e-mail')
        throw err
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>

<style scoped>
::v-deep .btn-custom-email {
  font-size: 11.5px !important;
  padding: .40rem !important;
  height: 32px !important;
  display: inline-flex !important;
  align-items: center !important;
}
</style>
